import Modal from "../Base/Modal";
import { FiX } from "react-icons/fi";
import SuccessModal from "../SuccessModal";
import {useState} from "react";
import BaseTimeline from "../Base/BaseTimeline";

interface PropsI {
    showModal: boolean;
    onClose : ()=>void;
}

const RSAProcessProgressStage = ({ showModal, onClose }: PropsI) => {
    const [isTransferSubmitted, setTransferSubmitted] = useState(false);

    const toggleTransferSubmitted = () => setTransferSubmitted(isTransferSubmitted);

    return (
        <>
            {
                !isTransferSubmitted ?
                    <Modal
                        showModal={showModal}
                        onClose={onClose}
                        className="rsa-progress-modal"
                    >
                        <div className="modal-head">
                            <div className="flex items-center">
                                Process Progress Stage
                            </div>
                            <button className="btn btn-text" onClick={onClose}>
                                <FiX className="text-3xl" />
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="mb-8">
                                status: <span className="text-primaryDark">Processing</span>
                            </div>
                            <div className="approval-text">
                                Levels of Approval: 3
                            </div>
                            <div className="timeline">
                                <BaseTimeline timelineStep={0}>
                                    <div className="timeline-texts">
                                        <div  className="text-grayscaleBody">Request Approval  (<span className="text-success">Approved</span>)</div>
                                        <div className="text-grayscaleBody">
                                            <span className="font-semibold">Approver:</span> Olumuyiwa Theophilus
                                        </div>
                                    </div>
                                    <div className="timeline-texts">
                                        <div  className="text-grayscaleBody">Request Approval  (<span className="text-warning">Pending</span>)</div>
                                        <div className="text-grayscaleBody">
                                            <span className="font-semibold">Approver:</span> Azeez Akeem
                                        </div>
                                    </div>
                                    <div className="timeline-texts">
                                        <div  className="text-grayscaleBody">Request Approval  (<span className="text-warning">Pending</span>)</div>
                                        <div className="text-grayscaleBody">
                                            <span className="font-semibold">Approver:</span> Bolanle Ayodeji
                                        </div>
                                    </div>
                                </BaseTimeline>

                            </div>
                            <div className="message">
                                <div className="message__head">
                                    Message Approver
                                </div>

                                <div className="form__group">
                                        <label htmlFor="" className="form__label">Approver</label>
                                        <input type="text" className="form__input"  />
                                    </div>
                                    <div className="form__group">
                                        <label htmlFor="" className="form__label">Message <span className="text-danger">*</span></label>
                                        <textarea name="" id="" className="form__input" rows={5} />
                                    </div>
                                    <div className="flex justify-end mb-6">
                                        <button className="btn btn-outline mr-4" onClick={onClose}>
                                            Cancel
                                        </button>
                                        <button className="btn btn-primary" onClick={toggleTransferSubmitted}>
                                            Submit
                                        </button>
                                    </div>

                            </div>
                        </div>
                    </Modal>
                    :
                    <SuccessModal
                        showModal={true} onClose={onClose}
                        note={"Your RSA transfer has been submitted successfully."}
                    />
            }
        </>
    )
}
export default RSAProcessProgressStage;